import NietErnstigeBloedingenOnderVka from "../../../../src/client/lta-antistolling/niet-ernstige-bloedingen-onder-vka.json";
import * as React from 'react';
export default {
  NietErnstigeBloedingenOnderVka,
  React
};